module.exports = __webpack_public_path__ + "img/illusThrones4.88e0847e.jpg";